
import React from 'react';
import { ArrowRight, BookOpen, Bookmark } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export interface Topic {
  id: string;
  title: string;
  arabicTitle: string;
  description: string;
  questionCount: number;
}

interface TopicSelectorProps {
  topics: Topic[];
  onSelectTopic: (topicId: string) => void;
}

const TopicSelector: React.FC<TopicSelectorProps> = ({ topics, onSelectTopic }) => {
  return (
    <div className="w-full max-w-4xl mx-auto">
      <h2 className="text-3xl font-serif font-bold mb-8 text-center">
        Choose a Topic to Practice
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {topics.map((topic) => (
          <Card 
            key={topic.id}
            className="cursor-pointer hover:shadow-soft-lg transition-all-soft"
            onClick={() => onSelectTopic(topic.id)}
          >
            <CardHeader className="pb-2">
              <div className="flex justify-between items-start">
                <div>
                  <CardTitle className="text-xl">{topic.title}</CardTitle>
                  <div className="text-arabic mt-1 text-lg">{topic.arabicTitle}</div>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="mt-2 text-muted-foreground">
                {topic.description}
              </CardDescription>
              
              <div className="flex justify-between items-center mt-4">
                <div className="flex items-center text-sm text-muted-foreground">
                  <BookOpen className="mr-1 h-4 w-4" />
                  {topic.questionCount} questions
                </div>
                <div className="flex items-center text-sm font-medium text-primary hover:text-primary/80 transition-colors">
                  Start practicing
                  <ArrowRight className="ml-1 h-4 w-4" />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default TopicSelector;
